import { render, staticRenderFns } from "./SwoopLogo.vue?vue&type=template&id=b92bb084&"
import script from "./SwoopLogo.vue?vue&type=script&lang=js&"
export * from "./SwoopLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports